import { render } from "./HeroBar.vue?vue&type=template&id=09f84986"
import script from "./HeroBar.vue?vue&type=script&lang=js"
export * from "./HeroBar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__